module.exports = __webpack_public_path__ + "img/kommune-1411.af13a04e.svg";